import { DataField, H2, Section } from "./common-components";

export const EligibilityInformation = ({formType}) => {
  // TODO: populate data from form
  return (
    <Section formType = {formType}>
      <H2>Eligibility Information</H2>
      <div className="grid grid-cols-2">
        <DataField label="Max Claims / Year" value={4} />
        <DataField label="Submitted" value={2} />
      </div>
    </Section>
  );
};
